const WorkerHousingQuery = (id) => {
    return `
    query {
      deleteWorkerHousing(id: "${id}")
    } 
    `
}

export default WorkerHousingQuery